export const checkoutUrl = 'https://100mapaskinesiovisual.impultienda.ar'

export const brand = {
  eyebrow: 'Para entrenadores personales e instructores de gimnasio',
  headline: '100 ejercicios ya analizados.',
  headlineAccent: 'Deja de buscar explicaciones entre vídeos y manuales.',
  name: 'Atlas Kinesio-Visual',
  subheadline: '100 mapas visuales + 6 bonos prácticos',
  description:
    'Músculos implicados, planos anatómicos, ejecución correcta, errores comunes y variantes: todo organizado en mapas visuales listos para consultar cuando los necesites.',
  tagline: 'Elige. Abre. Explica con más seguridad.',
}

export const heroCta = 'Quiero el Atlas completo'

export const heroNote = 'Acceso inmediato · PDF imprimibles · Pago único'

export const heroGuarantee = 'Garantía de 7 días o te devolvemos tu dinero.'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '100', label: 'Mapas visuales' },
  { value: '100', label: 'Ejercicios analizados' },
  { value: '3', label: 'Áreas de entrenamiento' },
  { value: '6', label: 'Bonos prácticos' },
]

export interface Situation {
  title: string
  text: string
}

export const situationsTitle = '¿Te reconoces en alguna de estas situaciones?'

export const situationsIntro =
  'Si trabajas como entrenador personal, probablemente alguna te resulte familiar.'

export const situations: Situation[] = [
  {
    title: 'Un cliente te hace una pregunta de anatomía.',
    text: 'Conoces el ejercicio, pero explicar con claridad qué músculos trabajan no siempre es tan sencillo.',
  },
  {
    title: 'Detectas un error técnico, pero te cuesta explicarlo.',
    text: 'Te gustaría tener una referencia clara para revisar el movimiento y las posibles correcciones.',
  },
  {
    title: 'Pierdes tiempo entre vídeos, libros y apuntes.',
    text: 'Cada vez que quieres comprobar los detalles de un ejercicio, tienes que buscar información en varias fuentes.',
  },
  {
    title: 'Conoces la teoría, pero aplicarla lleva tiempo.',
    text: 'Relacionar músculos, planos anatómicos y ejercicios reales no siempre resulta inmediato.',
  },
]

export const situationsClosing =
  'No te falta preparación. Te falta una referencia visual que puedas consultar cuando la necesites.'

export const comparisonCopy = {
  title: 'De información dispersa a 100 ejercicios ya organizados.',
  oldEyebrow: 'Antes',
  oldLabel: 'Sin el Atlas',
  atlasEyebrow: 'Después',
  atlasLabel: 'Con el Atlas',
  closing: 'Menos búsquedas. Más tiempo para tus clientes.',
}

export const comparisonOld: string[] = [
  'Buscas explicaciones entre vídeos y manuales diferentes.',
  'Tienes apuntes dispersos sobre músculos y movimientos.',
  'Pierdes tiempo buscando de nuevo la misma información.',
  'Tienes que conectar por tu cuenta la teoría con cada ejercicio.',
]

export const comparisonAtlas: string[] = [
  '100 ejercicios ya analizados y organizados.',
  'Músculos, técnica y movimiento en un mismo mapa.',
  'Errores comunes y variantes fáciles de consultar.',
  'Anatomía aplicada a ejercicios reales.',
]

export interface DemoStep {
  number: string
  title: string
  text: string
}

export const demoCopy = {
  title: 'Un cliente te hace una pregunta. Tú ya tienes el análisis listo para consultar.',
  questionLabel: 'Un cliente te pregunta:',
  question: '¿Qué músculos estoy trabajando con la sentadilla?',
}

export const demoSteps: DemoStep[] = [
  {
    number: '01',
    title: 'Elige',
    text: 'Abre la sección de Tren inferior y busca el mapa de la sentadilla.',
  },
  {
    number: '02',
    title: 'Consulta',
    text: 'Revisa los músculos implicados, la ejecución y los errores más frecuentes.',
  },
  {
    number: '03',
    title: 'Explica',
    text: 'Utiliza el análisis como referencia para dar una explicación más clara a tu cliente.',
  },
]

export const galleryCopy = {
  title: 'Mira los mapas por dentro.',
  subtitle:
    'Ejercicios reales analizados de forma visual, con la información esencial ya organizada.',
  footer: '100 ejercicios analizados. Un único sistema listo para consultar.',
  cta: 'Quiero los 100 mapas visuales',
}

export interface GalleryItem {
  title: string
  caption: string
  image: string
}

export const gallery: GalleryItem[] = [
  {
    title: 'Sentadilla libre',
    caption:
      'Músculos principales, estabilizadores, plano anatómico y errores más comunes: todo en un único mapa.',
    image:
      'https://cdn.magicpatterns.com/uploads/vcLdY9d7yzmQZC1oYeNzrV/Captura_de_pantalla_2026-10-11_a_la(s)_11.34.06_p._m..png',
  },
  {
    title: 'Sentadilla búlgara',
    caption: 'Trabajo unilateral: qué se estabiliza, qué se compensa y cómo corregirlo.',
    image:
      'https://cdn.magicpatterns.com/uploads/9s7vu8RCoEFTCw6vjdrGTM/Captura_de_pantalla_2026-10-11_a_la(s)_11.34.27_p._m..png',
  },
  {
    title: 'Press inclinado',
    caption:
      'Porción clavicular del pectoral, manguito rotador y trayectoria correcta de la barra.',
    image:
      'https://cdn.magicpatterns.com/uploads/kaVdurD8gajNdujQgrTqJC/Captura_de_pantalla_2026-10-11_a_la(s)_11.34.54_p._m..png',
  },
  {
    title: 'Crossover',
    caption:
      'Aducción horizontal en el plano transversal y control de la tensión en el pectoral.',
    image:
      'https://cdn.magicpatterns.com/uploads/aFvwesLKudtbYoPeQ5q4Zr/Captura_de_pantalla_2026-10-11_a_la(s)_11.35.13_p._m..png',
  },
  {
    title: 'Remo con barra',
    caption: 'Retracción escapular, cadena posterior y por qué el impulso arruina el ejercicio.',
    image:
      'https://cdn.magicpatterns.com/uploads/b1cra2cPW53nY2Dq6Aoo8Q/Captura_de_pantalla_2026-10-11_a_la(s)_11.35.43_p._m..png',
  },
]

export const systemCopy = {
  title: '100 ejercicios ya analizados para ti.',
  subtitle: 'Un sistema visual completo, organizado en tres áreas de entrenamiento.',
  includesTitle: 'En cada mapa encontrarás:',
  closing:
    'No es un simple ebook de anatomía. Es una referencia visual para comprender y explicar los ejercicios.',
}

export interface Module {
  number: string
  title: string
  detail: string
  summary: string
  description: string
  spine: string
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Tren inferior',
    detail: '40 mapas visuales',
    summary:
      'Sentadillas, peso muerto, hip thrust, zancadas, prensa de piernas y sus principales variantes.',
    description:
      'Músculos implicados, técnica y errores comunes en los principales ejercicios del tren inferior.',
    spine: 'bg-blue-400',
  },
  {
    number: '02',
    title: 'Tren superior',
    detail: '40 mapas visuales',
    summary:
      'Press de banca, flexiones, dominadas, remos, jalón al pecho y ejercicios de aislamiento.',
    description: 'Análisis visuales de los principales movimientos de empuje y tracción.',
    spine: 'bg-blue-600',
  },
  {
    number: '03',
    title: 'Core y estabilización',
    detail: '20 mapas visuales',
    summary:
      'Planchas, dead bug, bird dog, ejercicios de antirrotación y control lumbopélvico.',
    description: 'Estabilización, músculos implicados y detalles del movimiento.',
    spine: 'bg-blue-900',
  },
]

export const mapIncludes: string[] = [
  'Músculos principales y secundarios.',
  'Músculos estabilizadores.',
  'Planos anatómicos y cadenas cinéticas.',
  'Ejecución correcta.',
  'Errores comunes y posibles correcciones.',
  'Variantes e indicaciones prácticas.',
]

export interface Bonus {
  tag: string
  title: string
  benefit: string
}

export const bonusesCopy = {
  title: 'Además, recibes 6 bonos prácticos.',
  subtitle: 'Herramientas adicionales para analizar, repasar y explicar los ejercicios.',
  badge: 'Incluido',
  closing: 'Los 6 bonos ya están incluidos en tu Atlas.',
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bono 01',
    title: 'Guía antibloqueo',
    benefit: 'Esquemas prácticos para explicar los ejercicios de forma clara y estructurada.',
  },
  {
    tag: 'Bono 02',
    title: 'Recorrido de 7 días',
    benefit: 'Un recorrido organizado para consolidar el análisis de los ejercicios.',
  },
  {
    tag: 'Bono 03',
    title: 'Planificador de repaso',
    benefit: 'Esquemas de repaso de 7 días, 3 días y 24 horas.',
  },
  {
    tag: 'Bono 04',
    title: 'Checklist de 60 segundos',
    benefit: 'Una secuencia rápida para analizar cada ejercicio con método.',
  },
  {
    tag: 'Bono 05',
    title: 'Cuaderno práctico',
    benefit: '20 ejercicios con ejemplos de análisis y explicación.',
  },
  {
    tag: 'Bono 06',
    title: 'Diccionario exprés',
    benefit: 'Músculos, movimientos y planos anatómicos explicados de forma sencilla.',
  },
]

export interface Testimonial {
  initials: string
  quote: string
  author: string
  role: string
  city?: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'GR',
    quote:
      'Ya conocía muchos conceptos, pero me costaba relacionarlos con los ejercicios. Verlos explicados de forma visual me ayudó a entender mucho mejor qué ocurre durante cada movimiento.',
    author: 'Giulia R.',
    role: 'Estudiante de Ciencias del Deporte',
  },
  {
    initials: 'ML',
    quote:
      'Lo uso sobre todo cuando quiero repasar rápidamente un ejercicio. Me gusta porque encuentro enseguida los músculos implicados, el movimiento y los errores más comunes sin buscar entre mil apuntes.',
    author: 'Marco L.',
    role: 'Entrenador personal',
  },
  {
    initials: 'EF',
    quote:
      'Tenía poco tiempo para repasar antes del examen y los mapas me ayudaron a poner orden. Algunos temas que en los libros me parecían confusos se volvieron mucho más claros.',
    author: 'Elisa F.',
    role: 'Estudiante',
  },
]

export const guaranteeCopy = {
  title: '7 días de garantía. Compra con tranquilidad.',
  paragraphs: [
    'Consulta los mapas y explora los materiales incluidos.',
    'Si durante los 7 días posteriores a la compra consideras que el Atlas no se ajusta a tus necesidades, puedes solicitar la devolución según las condiciones de la garantía.',
  ],
  closing: 'Un solo pago. Sin suscripciones. Acceso de por vida.',
}

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Es adecuado para entrenadores personales que están empezando?',
    answer:
      'Sí. Los mapas ayudan a conectar la anatomía con ejercicios reales y pueden utilizarse como referencia durante tu preparación profesional.',
  },
  {
    question: '¿Puedo consultarlo desde el móvil mientras trabajo?',
    answer:
      'Sí. Puedes abrir los PDF desde el móvil, la tablet o el ordenador cuando necesites revisar un ejercicio.',
  },
  {
    question: '¿Incluye programas de entrenamiento ya preparados?',
    answer:
      'No. Es un sistema de análisis visual de los ejercicios, no una colección de programas de entrenamiento personalizados.',
  },
  {
    question: '¿Puedo imprimir los mapas?',
    answer: 'Sí. Los materiales se entregan en PDF imprimibles.',
  },
  {
    question: '¿Cómo recibo el Atlas? ¿Tengo que pagar todos los meses?',
    answer:
      'Recibes acceso al material digital después de completar la compra. Es un único pago de 19 €, sin suscripciones.',
  },
  {
    question: '¿Qué ocurre si no estoy satisfecho?',
    answer:
      'Puedes solicitar la devolución durante los 7 días posteriores a la compra, según las condiciones de la garantía.',
  },
]

export interface Offer {
  title: string
  name: string
  summary: string
  includes: string[]
  price: string
  currency: string
  cta: string
  note: string
}

export const offer: Offer = {
  title: 'Tu Atlas visual completo. Todo en una única compra.',
  name: 'Atlas Kinesio-Visual',
  summary: '100 mapas visuales + 6 bonos prácticos',
  includes: [
    '100 ejercicios ya analizados',
    '40 mapas de tren inferior',
    '40 mapas de tren superior',
    '20 mapas de core y estabilización',
    'Músculos, técnica, errores y variantes',
    'Los 6 bonos incluidos',
    'PDF imprimibles',
    'Acceso inmediato y de por vida',
  ],
  price: '19',
  currency: '€',
  cta: 'Sí, quiero el Atlas completo',
  note: 'Pago único · Sin suscripciones · Garantía de 7 días',
}

export const finalCtaCopy = {
  title: '100 ejercicios ya analizados. Listos cuando los necesites.',
  subtitle:
    'Deja de buscar las mismas explicaciones. Ten músculos, técnica, errores comunes y variantes organizados en un único Atlas visual.',
  summary: '100 mapas visuales + 6 bonos',
  cta: 'Quiero el Atlas completo',
}

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/kg87mt8mqd5qyGu7pd8d97/image.png'
